import { redirect, type RouteObject } from 'react-router';

import { CustodianProfileOnboardingRoutesEnum } from 'src/pages/CustodianProfileOnboarding';
import { CustodianProfileRoutesEnum } from 'src/pages/CustodianProfile';

export const custodianProfilesRoutes: RouteObject = {
  path: 'custodian-profiles',
  lazy: async () => {
    const { default: Component } = await import('src/pages/CustodianProfiles');

    return { Component };
  },
};

export const custodianProfileRoutes: RouteObject = {
  path: 'custodian-profiles/:id/*',
  lazy: async () => {
    const { CustodianProfileLayout: Layout } = await import('src/pages/CustodianProfile/ui');

    return { Component: Layout };
  },

  loader: ({ params }) => {
    const { id, '*': path = '' } = params;

    if (!path) return redirect(`/custodian-profiles/${id}/${CustodianProfileRoutesEnum.Overview}`);

    if (!Object.values(CustodianProfileRoutesEnum).includes(path as CustodianProfileRoutesEnum))
      return redirect('/404');

    return null;
  },
  children: [
    {
      path: CustodianProfileRoutesEnum.Overview,
      lazy: async () => {
        const { default: Component } = await import('src/pages/CustodianProfile/Overview');

        return { Component };
      },
    },
    {
      path: CustodianProfileRoutesEnum.Assets,
      lazy: async () => {
        const { default: Component } = await import('src/pages/CustodianProfile/Assets');

        return { Component };
      },
    },
    {
      path: CustodianProfileRoutesEnum.Operations,
      lazy: async () => {
        const { default: Component } = await import('src/pages/CustodianProfile/Operations');

        return { Component };
      },
    },
    {
      path: CustodianProfileRoutesEnum.Providers,
      lazy: async () => {
        const { default: Component } = await import('src/pages/CustodianProfile/Providers');

        return { Component };
      },
    },
  ],
};

export const custodianProfilesOnboardingRoutes: RouteObject = {
  path: 'custodian-profiles/onboarding',
  children: [
    {
      path: ':id/*',
      lazy: async () => {
        const { Layout } = await import('src/pages/CustodianProfileOnboarding/ui');

        return { Component: Layout };
      },
      children: [
        {
          path: CustodianProfileOnboardingRoutesEnum.Assets,
          lazy: async () => {
            const { default: Component } = await import('src/pages/CustodianProfileOnboarding/Assets');

            return { Component };
          },
        },
        {
          path: CustodianProfileOnboardingRoutesEnum.Operations,
          lazy: async () => {
            const { default: Component } = await import('src/pages/CustodianProfileOnboarding/Operations');

            return { Component };
          },
        },
        {
          path: CustodianProfileOnboardingRoutesEnum.Summary,
          lazy: async () => {
            const { default: Component } = await import('src/pages/CustodianProfileOnboarding/Summary');

            return { Component };
          },
        },
      ],
    },
  ],
};
